<template>
    <div class="checkbox">
        <input
            class="checkbox__input"
            type="checkbox"
            v-model="checkbox"
            :id="checkboxName"
            :name="checkboxName">
        <label class="checkbox__label link" :for="checkboxName">{{ checkboxText }}</label>
    </div>
</template>

<script>
import {sameAs} from "vuelidate/lib/validators";

export default {
    name: "customCheckbox",
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        checkboxName: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
        },
        placeholder: {
            type: String,
            default: ""
        },
        checkboxText: {
            type: String,
            default: ""
        }
    },
    computed: {
        checkbox: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }
    }
};
</script>
